<template>
  <div class="index-chart" v-loading="loading" element-loading-text="数据加载中" v-cloak>
    <div class="chart-header">
      <div class="view-title">
        <!-- <i class="iconfont-erp icondingdanqushi"></i> 订单趋势 -->

        <div class="view-switch-wrap">
          <div
            @click="OrderType = 1"
            :class="[OrderType == 1 ? 'view-switch-item-active' : '']"
            class="view-switch-item "
          >
            ERP订单
          </div>
          <div
            @click="OrderType = 2"
            :class="[OrderType == 2 ? 'view-switch-item-active' : '']"
            class="view-switch-item"
          >
            1688平台订单
          </div>
        </div>
      </div>
      <el-form :inline="true" :model="query" class="chart-form">
        <el-form-item>
          <el-date-picker
            @change="timeChange"
            v-model="query.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="veiw-charts-container">
      <el-row>
        <el-col :span="18"
          ><div class="grid-content bg-purple-dark">
            <div style="height:400px;margin-top:50px" id="container"></div></div
        ></el-col>
        <el-col :span="6">
          <div class="view-progress-wrap">
            <div class="view-progress-item" id="view-progress-old">
              <el-progress
                type="circle"
                :stroke-width="12"
                color="#ff5500"
                :percentage="OldCustomer"
              ></el-progress>
              <p class="cril-title">老客占比</p>
            </div>
            <div class="view-progress-item" id="view-progress-reshopping">
              <el-progress
                :stroke-width="12"
                type="circle"
                color="#88CC96"
                :percentage="RepurchaseRate"
              ></el-progress>
              <p class="cril-title">复购率</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import dayjs from "dayjs";
var myChart = null;
export default {
  data() {
    const defaultEnd = new Date();
    const defaultStart = new Date();
    defaultStart.setTime(defaultStart.getTime() - 3600 * 1000 * 24 * 7);
    // myChart = echarts.init(document.getElementById("container"));
    return {
      OldCustomer: 0,
      RepurchaseRate: 0,
      loading: false,
      query: {
        time: [defaultStart, defaultEnd],
      },
      OrderType: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end, "day"]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end, "day"]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const start = dayjs()
                .subtract(12, "month")
                .format("YYYY-MM-DD");
              const end = dayjs().format("YYYY-MM-DD");
              picker.$emit("pick", [start, end, "month"]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getDetail();
    });
    this.getColumnLineRenderData("month");
  },
  watch: {
    OrderType() {
      this.getColumnLineRenderData();
    },
  },
  methods: {
    // 监听picker change
    timeChange() {
      this.getColumnLineRenderData();
    },
    getColumnLineRenderData(type) {
      let parms;
      let OrderType = this.OrderType;
      switch (type) {
        case "week":
          parms = {
            StartTime: dayjs()
              .subtract(6, "day")
              .format("YYYY-MM-DD"),
            EndTime: dayjs().format("YYYY-MM-DD"),
            Interval: "day",
            OrderType: OrderType,
          };
          break;
        case "day":
          parms = {
            StartTime: dayjs()
              .subtract(30, "day")
              .format("YYYY-MM-DD"),
            EndTime: dayjs().format("YYYY-MM-DD"),
            Interval: "day",
            OrderType: OrderType,
          };
          break;
        case "month":
          parms = {
            StartTime: dayjs()
              .subtract(12, "month")
              .format("YYYY-MM-DD"),
            EndTime: dayjs().format("YYYY-MM-DD"),
            Interval: "month",
            OrderType: OrderType,
          };
          break;
        default:
          parms = {
            StartTime: dayjs(this.query.time[0]).format("YYYY-MM-DD"),
            EndTime: dayjs(this.query.time[1]).format("YYYY-MM-DD"),
            Interval: this.query.time[2] ? this.query.time[2] : "day",
            OrderType: OrderType,
          };
      }

      this.$ajax.post("/api/Order/GetStatisticalList", parms).then((res) => {
        // let data = [];
        let BarData = [];
        let LineData = [];
        const list = res.List;
        for (var i = 0; i < list.length; i++) {
          BarData.push(list[i].DealMoneySum);
          LineData.push(list[i].DealOrderCount);
        }
        var options = {
          bar: BarData,
          line: LineData,
        };
        this.eChartDonutRender(
          options,
          this.createxAxisData(parms.Interval, options.bar.length, parms.EndTime)
        );
        //老客占比
        //复购率
        this.OldCustomer = res.OldCustomer;
        this.RepurchaseRate = res.RepurchaseRate;
      });
    },
    createxAxisData(index, length, endTime) {
      // console.log("index", index);
      var xAxisData = [];
      switch (index) {
        case "week":
          for (let i = length - 1; i >= 0; i--) {
            xAxisData.push(
              `${dayjs(endTime)
                .subtract(i, "day")
                .format("MM-DD")}`
            );
          }
          break;
        case "day":
          for (let i = length - 1; i >= 0; i--) {
            xAxisData.push(
              `${dayjs(endTime)
                .subtract(i, "day")
                .format("MM-DD")}`
            );
          }

          break;
        case "month":
          for (let i = length - 1; i >= 0; i--) {
            xAxisData.push(
              `${dayjs(endTime)
                .subtract(i, "month")
                .format("YYYY年MM月")}`
            );
          }

          break;
        default:
          for (let i = length - 1; i >= 0; i--) {
            xAxisData.push(
              `${dayjs(endTime)
                .subtract(i, "day")
                .format("MM-DD")}`
            );
          }
      }
      return xAxisData;
    },

    eChartDonutRender(data, xAxisData) {
      myChart = null;
      myChart = echarts.init(document.getElementById("container"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        color: ["#ff5500", "green"],
        legend: {
          data: ["销售额", "订单数"],
          bottom: 0,
        },
        grid: {
          top: "10%",
          bottom: "12%",
          left: "12%",
          right: "8%",
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "销售额",
            nameTextStyle: {
              fontSize: 20,
              fontStyle: "bold",
            },
            min: 0,
            max: Math.max(...data.bar),
            axisLabel: {
              formatter: "{value} 元",
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                // color: ["rgb(0 ,0,0,1)"],
              },
            },
            axisLabel: {
              formatter: function(val) {
                if (val > 9999) {
                  return (val / 10000).toFixed(1) + "w";
                } else if (val > 999) {
                  return (val / 1000).toFixed(1) + "k";
                } else {
                  return val;
                }
              },
              fontSize: 14,
            },
          },
          {
            type: "value",
            name: "订单数",
            nameTextStyle: {
              fontSize: 20,
              fontStyle: "bold",
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
              },
            },
            min: 0,
            max: Math.max(...data.line),
            axisLabel: {
              formatter: "{value} 单",
            },
          },
        ],
        series: [
          {
            name: "销售额",
            type: "bar",
            data: data.bar,
            barWidth: data.bar.length > 20 ? 10 : 30,

            itemStyle: {
              normal: {
                color: function() {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 1,
                      color: "#ff6e5c",
                    },
                    {
                      offset: 0,
                      color: "#f54723",
                    },
                  ]);
                },
              },
            },
          },
          {
            name: "订单数",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            data: data.line,

            cursor: "pointer",
            lineStyle: {
              width: 5,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#88CC96",
                },
                {
                  offset: 1,
                  color: "green",
                },
              ]),
              width: 1,
            },
          },
        ],
      };
      myChart.setOption(option);
    },

    getDetail() {},
  },
};
</script>

<style lang="scss" scoped>
.cril-title {
  padding: 5px 0;
  color: #333;
}
.index-chart {
  // height: 463px;
  padding: 20px;
  background: #fff;
}

.chart-header {
  overflow: hidden;
  position: relative;
  // border-bottom: 1px;
  // border-color: #eee;
  // border-style: solid;
  &::after {
    position: absolute;
    top: 55px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 1px;
    // border-radius: 4px;
    background-color: #eee;
    content: "";
  }
  .view-title {
    float: left;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    .view-switch-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;

      width: 200px;
      height: 40px;
      //   background-color: red;
      .view-switch-item {
        width: 100px;
        height: 40px;
        line-height: 40px;
        position: relative;
        text-align: center;
        cursor: pointer;
      }
      .view-switch-item-active {
        color: #ff5500;
        &::after {
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          // border-radius: 4px;
          background-color: #ff5500;
          content: "";
        }
      }
    }
    i {
      padding-right: 5px;
      font-weight: normal;
      font-size: 18px;
      color: #333;
    }
  }

  .chart-form {
    float: right;
  }
}
.view-progress-wrap {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  .view-progress-item {
    width: 100%;
    height: 170px;
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // background: red;
  }
}
</style>
